import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const PrivateRoute: React.FC = () => {
    const { isAuthenticated, isAgreementChecked } = useAuth();

    if (!isAgreementChecked) {
        return <Navigate to="/" />;
    }

    if (isAuthenticated) {
        return <Outlet />;
    } else {
        return <Navigate to="/Login" />;
    }
};

export default PrivateRoute;
